import { Col, Row, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import {
  getQueryParams,
  generateQuery,
} from "../../../modules/utilities/utility";
import AllocatedOrders from "../../../modules/misc_orders/Allocated";
import B2BOrders from "../../../modules/misc_orders/B2B";
import FlaggedOrders from "../../../modules/misc_orders/Flagged";
import FlaggedInvoices from "../../../modules/misc_orders/FlaggedInvoices";
import InternationalOrders from "../../../modules/misc_orders/InternationalOrders";
import OnholdOrders from "../../../modules/misc_orders/Onhold";
import OtherOrders from "../../../modules/misc_orders/Others";
import ProzoPending from "../../../modules/misc_orders/ProzoPending";
import ShippingPendingOrders from "../../../modules/misc_orders/ShippingPendingOrders";
import secureLocalStorage from "react-secure-storage";

const { TabPane } = Tabs;

const ODAList = () => {
  const [tab, setTab] = useState(() => {
    return getQueryParams("tab") || "flagged-orders";
  });
  const [userLevel] = useState(secureLocalStorage.getItem("rep!level"));

  return (
    <Row justify="end" gutter={[8, 8]}>
      <Col span="24">
        {userLevel === null && (
          <Tabs
            type="card"
            defaultActiveKey={tab}
            destroyInactiveTabPane={true}
            onChange={setTab}
          >
            <TabPane key="allocated_orders" tab="Allocated Orders">
              <AllocatedOrders />
            </TabPane>
            <TabPane key="b2b" tab="B2B Orders">
              <B2BOrders />
            </TabPane>
            <TabPane key="flaggedInvoice" tab="Flagged Invoice">
              <FlaggedInvoices />
            </TabPane>
            <TabPane key="flagged_orders" tab="Flagged Orders">
              <FlaggedOrders />
            </TabPane>
            <TabPane key="international_orders" tab="International Orders">
              <InternationalOrders />
            </TabPane>

            <TabPane key="on_hold" tab="OnHold Orders">
              <OnholdOrders />
            </TabPane>

            <TabPane key="other_orders" tab="Other Orders">
              <OtherOrders />
            </TabPane>
            <TabPane key="prozoPendingOrders" tab="Prozo Pending Orders">
              <ProzoPending />
            </TabPane>
            <TabPane key="shippingPendingOrders" tab="Pending for shipping">
              <ShippingPendingOrders />
            </TabPane>
          </Tabs>
        )}
      </Col>
    </Row>
  );
};

export default ODAList;
